import ShareMsgBase from './A_G.ShareMsgBase';

class MsgLives extends ShareMsgBase {
  /**
   * The message that sends back when you got the lives and you want to thank your friend via message
   * @param {function} onAllImagesReadyCallback
   */
  constructor(onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.bg = this._addExtImage(0, 0, 'img/Msg_Life.jpg', 0, null, null);
    this.title = this.add(new G.Text(336, 43, 'You got lives!', {
      style: 'msg-white',
      fontSize: '50px',
    }, 0.5, 420));

    this._objectLoadComplete();
  }
}

G.MsgLives = MsgLives;
